import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import ProjectCategory from './ProjectCategory';
function ProjectCategoryList() {
    return (
        <div className="projects">
            <Router>
            <ProjectCategory
                name="CLI Application"
                link="/projects#CLI"
            />
            <ProjectCategory
                name="Web Development"
                link="/projects#web"
            />
            <ProjectCategory
                name="Mobile Application"
                link="/projects#mob"
            />
            </Router>
        </div>
    );
}

export default ProjectCategoryList;